import RouteTemplate from 'ember-route-template'
import type { TOC } from '@ember/component/template-only'
import { ResetScroll } from 'teacher-ui-client/modifiers/reset-scroll'
import type TeacherToolkitIndexRoute from 'teacher-ui-client/subscription-type/teacher-toolkit/index/route'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { ContentfulEdit } from 'teacher-ui-client/components/contentful/edit'
import { TeacherToolkitCategoriesList } from 'teacher-ui-client/components/teacher-toolkit/categories-list'
import { TeacherToolkitResourcesList } from 'teacher-ui-client/components/teacher-toolkit/resources-list'
import { isPresent } from '@ember/utils'

interface Signature {
  Args: {
    model: ModelFor<TeacherToolkitIndexRoute>
  }
}

function onlyDefined<T>(maybeDefined: (T | undefined)[]): T[] {
  return maybeDefined.filter(isPresent)
}

const TeacherToolkitIndexPage: TOC<Signature> = <template>
  <PageHeader>
    <:title>
      <h1 {{ResetScroll whenValueChanges=@model.selectedCategory.fields.name}}>
        {{@model.selectedCategory.fields.name}}
        <ContentfulEdit class="inline-block" @entryId={{@model.selectedCategory.sys.id}} />
      </h1>
    </:title>
  </PageHeader>

  {{#if @model.selectedCategory.fields.categories}}
    <TeacherToolkitCategoriesList class="mt-4" @categories={{onlyDefined @model.selectedCategory.fields.categories}} />
  {{else if @model.selectedCategory.fields.resources}}
    {{! This can happen if you end up on a "leaf" page, where the category name will already be in the page header  }}
    <TeacherToolkitResourcesList @resources={{onlyDefined @model.selectedCategory.fields.resources}} />
  {{/if}}
</template>

export default RouteTemplate(TeacherToolkitIndexPage)
